import { render, staticRenderFns } from "./WelcomeToAigc.vue?vue&type=template&id=27fdf283&scoped=true"
import script from "./WelcomeToAigc.vue?vue&type=script&lang=js"
export * from "./WelcomeToAigc.vue?vue&type=script&lang=js"
import style0 from "./WelcomeToAigc.vue?vue&type=style&index=0&id=27fdf283&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27fdf283",
  null
  
)

export default component.exports